/**
 * @generated SignedSource<<0b3b784e2cde398cea659d1fce1e89cf>>
 * @relayHash b9e598fc582af257009f9796883809d7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 90f5cb6cf5d5933044dd2d1b7a0e2ad065babf181ac54e2218ccddc4144440bd

import type { ConcreteRequest, Query } from 'relay-runtime';
export type services_jira_projectOpsGenieAssociationV2_associatedOpsgenieTeamQueryAgg_Query$variables = {
  jiraProjectId: string;
};
export type services_jira_projectOpsGenieAssociationV2_associatedOpsgenieTeamQueryAgg_Query$data = {
  readonly devOps: {
    readonly ariGraph: {
      readonly teamRelationships: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly to: {
              readonly opsgenieTeam: {
                readonly id?: string;
                readonly name?: string | null | undefined;
              } | null | undefined;
            };
          };
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type services_jira_projectOpsGenieAssociationV2_associatedOpsgenieTeamQueryAgg_Query = {
  response: services_jira_projectOpsGenieAssociationV2_associatedOpsgenieTeamQueryAgg_Query$data;
  variables: services_jira_projectOpsGenieAssociationV2_associatedOpsgenieTeamQueryAgg_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "jiraProjectId"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5
  },
  {
    "kind": "Variable",
    "name": "from",
    "variableName": "jiraProjectId"
  },
  {
    "kind": "Literal",
    "name": "type",
    "value": "project-associated-opsgenie-team"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "name": "name"
    }
  ],
  "type": "OpsgenieTeam"
},
v4 = [
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "services_jira_projectOpsGenieAssociationV2_associatedOpsgenieTeamQueryAgg_Query",
    "selections": [
      {
        "concreteType": "DevOps",
        "kind": "LinkedField",
        "name": "devOps",
        "plural": false,
        "selections": [
          {
            "concreteType": "AriGraph",
            "kind": "LinkedField",
            "name": "ariGraph",
            "plural": false,
            "selections": [
              {
                "alias": "teamRelationships",
                "args": (v1/*: any*/),
                "concreteType": "AriGraphRelationshipConnection",
                "kind": "LinkedField",
                "name": "relationships",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "AriGraphRelationshipEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "AriGraphRelationship",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "AriGraphRelationshipNode",
                            "kind": "LinkedField",
                            "name": "to",
                            "plural": false,
                            "selections": [
                              {
                                "alias": "opsgenieTeam",
                                "kind": "LinkedField",
                                "name": "data",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "services_jira_projectOpsGenieAssociationV2_associatedOpsgenieTeamQueryAgg_Query",
    "selections": [
      {
        "concreteType": "DevOps",
        "kind": "LinkedField",
        "name": "devOps",
        "plural": false,
        "selections": [
          {
            "concreteType": "AriGraph",
            "kind": "LinkedField",
            "name": "ariGraph",
            "plural": false,
            "selections": [
              {
                "alias": "teamRelationships",
                "args": (v1/*: any*/),
                "concreteType": "AriGraphRelationshipConnection",
                "kind": "LinkedField",
                "name": "relationships",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "AriGraphRelationshipEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "AriGraphRelationship",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "AriGraphRelationshipNode",
                            "kind": "LinkedField",
                            "name": "to",
                            "plural": false,
                            "selections": [
                              {
                                "alias": "opsgenieTeam",
                                "kind": "LinkedField",
                                "name": "data",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                  },
                                  (v3/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v4/*: any*/),
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v4/*: any*/),
                                    "type": "ConfluencePage"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v4/*: any*/),
                                    "type": "ConfluenceSpace"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v4/*: any*/),
                                    "type": "DevOpsFeatureFlag"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v4/*: any*/),
                                    "type": "DevOpsOperationsComponentDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v4/*: any*/),
                                    "type": "DevOpsOperationsIncidentDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v4/*: any*/),
                                    "type": "DevOpsOperationsPostIncidentReviewDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v4/*: any*/),
                                    "type": "DevOpsPullRequestDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v4/*: any*/),
                                    "type": "DevOpsRepository"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v4/*: any*/),
                                    "type": "DevOpsSecurityVulnerabilityDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v4/*: any*/),
                                    "type": "JiraConfluenceRemoteIssueLink"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v4/*: any*/),
                                    "type": "JiraCustomRemoteIssueLink"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v4/*: any*/),
                                    "type": "JiraIssueRemoteIssueLink"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v4/*: any*/),
                                    "type": "JiraWebRemoteIssueLink"
                                  }
                                ]
                              },
                              (v2/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "90f5cb6cf5d5933044dd2d1b7a0e2ad065babf181ac54e2218ccddc4144440bd",
    "metadata": {},
    "name": "services_jira_projectOpsGenieAssociationV2_associatedOpsgenieTeamQueryAgg_Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c44ccdde972733a378f8a06627fbbf62";

export default node;
